var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "card-dialog",
        {
          attrs: {
            persistent: "",
            width: 1000,
            title: _vm.$t("label.rat_appearance"),
            transition: false,
            "content-class": "rat-graph-dialog",
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function (ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "round-button",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            icon: "bar_chart",
                            disabled: _vm.disabled,
                            "data-testid": "rat_graph",
                          },
                        },
                        "round-button",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("button.appearance_graph")) +
                          "\n      "
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c("dialog-action", { on: { click: _vm.close } }, [
                    _vm._v(_vm._s(_vm.$t("button.close"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.dialogVisible,
            callback: function ($$v) {
              _vm.dialogVisible = $$v
            },
            expression: "dialogVisible",
          },
        },
        [
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rat-graph pa-4" },
            [
              !_vm.ready || !_vm.allEventsLoaded
                ? _c("v-progress-linear", {
                    attrs: {
                      indeterminate: !_vm.progress,
                      value: _vm.progress,
                    },
                  })
                : [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex align-center justify-space-between mb-3",
                      },
                      [
                        _c(
                          "v-btn-toggle",
                          {
                            attrs: {
                              mandatory: "",
                              dense: "",
                              color: "primary",
                            },
                            model: {
                              value: _vm.filterMode,
                              callback: function ($$v) {
                                _vm.filterMode = $$v
                              },
                              expression: "filterMode",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  value: "exclude_misdetection",
                                  small: "",
                                  "data-testid": "filter_exclude_misdetection",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("filter.exclude_misdetection"))
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  value: "pickup_only",
                                  small: "",
                                  "data-testid": "filter_pickup_only",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("filter.pickup_only")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  value: "all",
                                  small: "",
                                  "data-testid": "filter_all",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("filter.all")))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "detection-count",
                            attrs: { "data-testid": "detection_count" },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.$t("summary.detection_count", {
                                    count: _vm.eventsWithRat.length,
                                  })
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("bar-chart", {
                      attrs: {
                        data: _vm.chartData,
                        options: _vm.chartOptions,
                        styles: { flex: "1", minHeight: "0" },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "chart-caption text-right",
                        attrs: { "data-testid": "data_period" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.dataPeriodStart
                                ? _vm.$t("summary.data_period", {
                                    start: _vm.dataPeriodStart,
                                    end: _vm.dataPeriodEnd,
                                  })
                                : _vm.$t("summary.no_data_period")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }